import { ZigzagEvent } from '@common/log-manager';

export const useSendSellerZonLog = () => {
  const clickStoreProductMoreLog = (catalog_product_id: string, shop_id: string) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'seller_zone',
      object_type: 'button',
      object_id: 'see_more',
      data: JSON.stringify({ catalog_product_id: catalog_product_id, shop_id }),
    });
  };

  const clickLookBookMoreLog = (catalog_product_id: string, object_url: string) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'seller_zone',
      object_type: 'button',
      object_id: 'collection_all',
      object_url,
      data: JSON.stringify({ catalog_product_id }),
    });
  };

  const saveShopLog = (catalog_product_id: string, shop_id: string, brand_id?: string) => {
    return {
      category: 'add_bookmark',
      navigation: 'product_detail',
      object_section: 'seller_zone',
      object_type: 'shop',
      object_id: brand_id ?? shop_id,
      data: JSON.stringify({ catalog_product_id }),
    };
  };

  const removeSavedShopLog = (catalog_product_id: string, shop_id: string, brand_id?: string) => {
    return {
      category: 'remove_bookmark',
      navigation: 'product_detail',
      object_section: 'seller_zone',
      object_type: 'shop',
      object_id: brand_id ?? shop_id,
      data: JSON.stringify({ catalog_product_id }),
    };
  };

  const impressionSellerZoneProductLog = (
    original_product_id: string,
    catalog_product_id: string,
    object_idx: number,
    group_type: string,
  ) => {
    ZigzagEvent.subl({
      category: 'impression',
      navigation: 'product_detail',
      object_type: 'catalog',
      object_section: 'seller_zone',
      object_idx,
      object_id: catalog_product_id,
      data: JSON.stringify({ original_product_id, group_type }),
    });
  };

  const saveProductLog = (
    original_product_id: string,
    catalog_product_id: string,
    object_idx: number,
    group_type: string,
  ) => {
    return {
      category: 'save_product',
      navigation: 'product_detail',
      object_section: 'seller_zone',
      object_type: 'catalog',
      object_idx,
      object_id: catalog_product_id,
      data: JSON.stringify({ original_product_id, group_type }),
    };
  };

  const removeSavedProductLog = (
    original_product_id: string,
    catalog_product_id: string,
    object_idx: number,
    group_type: string,
  ) => {
    return {
      category: 'remove_save_product',
      navigation: 'product_detail',
      object_section: 'seller_zone',
      object_type: 'catalog',
      object_idx,
      object_id: catalog_product_id,
      data: JSON.stringify({ original_product_id, group_type }),
    };
  };

  const clickProductSellerLog = (
    original_product_id: string,
    catalog_product_id: string,
    object_idx: number,
    group_type: string,
  ) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'seller_zone',
      object_type: 'catalog',
      object_idx,
      object_id: catalog_product_id,
      data: JSON.stringify({ original_product_id, group_type }),
    });
  };

  return {
    clickStoreProductMoreLog,
    clickLookBookMoreLog,
    saveShopLog,
    removeSavedShopLog,
    impressionSellerZoneProductLog,
    saveProductLog,
    removeSavedProductLog,
    clickProductSellerLog,
  };
};
